import { Injectable } from '@angular/core';
import { AppConfigData } from '../config/appConfigData';
import { catchError, map, Observable, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  constructor(private http: HttpClient, private router: Router) { }

  //https://ripple-ai-app-uat.azurewebsites.net/v1/QA/ask-question

  ask_question(question: any): Observable<any> {
    return this.http.post<any>(AppConfigData.ask_question, question).pipe(
      map((res) => {
        return res;
      }),
      catchError((error) => {
        console.error('getMasters failed:', error);
        return throwError(() => new Error('Failed to load data')); // Rethrow the error to propagate it further
      })
    );
  }

  get_user_chat(): Observable<any> {
    return this.http.get<any>(AppConfigData.get_user_chat).pipe(
      map((res) => {
        return res;
      }),
      catchError((error) => {
        console.error('getMasters failed:', error);
        return throwError(() => new Error('Failed to load data')); // Rethrow the error to propagate it further
      })
    );
  }

  get_user_chat_history(): Observable<any> {
    return this.http.get<any>(AppConfigData.get_user_chat_history).pipe(
      map((res) => {
        return res;
      }),
      catchError((error) => {
        console.error('getMasters failed:', error);
        return throwError(() => new Error('Failed to load data')); // Rethrow the error to propagate it further
      })
    );
  }

  clear_chat(): Observable<any> {
    return this.http.get<any>(AppConfigData.clear_chat).pipe(
      map((res) => {
        return res;
      }),
      catchError((error) => {
        console.error('getMasters failed:', error);
        return throwError(() => new Error('Failed to load data')); // Rethrow the error to propagate it further
      })
    );
  }
  delete_chat_history(): Observable<any> {
    return this.http.get<any>(AppConfigData.delete_chat_history).pipe(
      map((res) => {
        return res;
      }),
      catchError((error) => {
        console.error('getMasters failed:', error);
        return throwError(() => new Error('Failed to load data')); // Rethrow the error to propagate it further
      })
    );
  }

  //
  get_balance_credits(): Observable<any> {
    return this.http.get<any>(AppConfigData.get_balance_credits).pipe(
      map((res) => {
        return res;
      }),
      catchError((error) => {
        console.error('getMasters failed:', error);
        return throwError(() => new Error('Failed to load data')); // Rethrow the error to propagate it further
      })
    );
  }
  purchase_tokens(payload: any): Observable<any> {
    return this.http.post<any>(AppConfigData.purchase_tokens, payload).pipe(
      map((res) => {
        return res;
      }),
      catchError((error) => {
        console.error('getMasters failed:', error);
        return throwError(() => new Error('Failed to load data')); // Rethrow the error to propagate it further
      })
    );
  }




  get_token_packages(): Observable<any> {
    return this.http.get<any>(AppConfigData.get_token_packages).pipe(
      map((res) => {
        return res;
      }),
      catchError((error) => {
        console.error('getMasters failed:', error);
        return throwError(() => new Error('Failed to load data')); // Rethrow the error to propagate it further
      })
    );
  }
  //get_token_packages
}